export enum InvitationTypeEnum {
  EVENT = 'EVENT',
}
